module.exports = __webpack_public_path__ + "static/media/type-square.600e214e.png";